import type { ShareChannel } from 'src/app/pages/psf/share/shared/types';

export const SHARE_CHANNELS: Partial<Record<ShareChannel, true>> = {
	copy: true,
	email: true,
	facebook: true,
	facebookMessenger: true,
	instagram: true,
	instagramStories: true,
	line: true,
	mobileNativeShare: true,
	nextdoor: true,
	reddit: true,
	sms: true,
	tiktok: true,
	twitter: true,
	vk: true,
	whatsapp: true,
};
